export interface BoatDetailsState {
  baseBoatId: string; // deprecated
  boatDetailsList: BoatDetails[]; // deprecated
  currentGroupId: string;
  boatGroupList: BoatGroupList;
}

export type BoatGroupList = BoatGroup[];

export interface BoatDetails {
  id: string,
  name: string;
  handicap: number;
}

export interface BoatGroup {
  id: string,
  name: string;
  handicapSystem: HandicapSystem;
  baseBoatId: string;
  boatDetails: BoatDetails[];
}

export enum HandicapSystem {
  PY = 'PY',
  YTC = 'YTC',
  IRC = 'IRC',
  NHC = 'NHC',
  TCF ='TCF'
}
